import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import StyledButton from "components/atoms/StyledButton";
import { additionalColors } from "constants/colors";
import { DeepInsight } from "reactQuery/hooks/apiTypes";
import { useModalStore, ModalNames } from "stores/zustandStore";

const cardStyles = makeStyles<Theme>((theme) => ({
    button: {
        marginTop: 12,
    },
    card: {
        width: "85%",
        height: "auto",
        marginBottom: 32,
    },
    editButton: {
        border: "2px solid",
        color: additionalColors.grey999,
        marginTop: theme.spacing(1),
    },
    text: {
        color: additionalColors.grey999,
        marginTop: theme.spacing(1),
    },
}));

export interface TimelineCardProps {
    hasTimeline: boolean;
    insight: DeepInsight;
    isEditModeActive: boolean;
}
const TimelineCard = ({
    hasTimeline,
    insight,
    isEditModeActive,
}: TimelineCardProps) => {
    const setModalVisible = useModalStore((state) => state.setModalVisible);
    const { stage } = insight;
    const styles = cardStyles();
    const addTimelineBtn = isEditModeActive ? (
        <StyledButton
            className={styles.button}
            color="primary"
            onClick={() => {
                setModalVisible(ModalNames.AddTimeline, { insight: insight });
            }}
            variant="contained"
        >
            Add Timeline
        </StyledButton>
    ) : null;

    const editTimelineBtn = isEditModeActive ? (
        <StyledButton
            className={styles.editButton}
            onClick={() => {
                setModalVisible(ModalNames.EditTimeline, { insight: insight });
            }}
            variant="outlined"
            data-testid="edit-timeline-card-button"
        >
            Edit
        </StyledButton>
    ) : null;

    return hasTimeline ? (
        <Card className={styles.card}>
            <CardContent>
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Typography className={styles.text} align="center">
                        {stage}
                    </Typography>
                    {editTimelineBtn}
                </Grid>
            </CardContent>
        </Card>
    ) : (
        <Grid container direction="column" justifyContent="center" alignItems="center">
            <Grid item>{addTimelineBtn}</Grid>
        </Grid>
    );
};

export default TimelineCard;
